import { Action, createReducer, on } from '@ngrx/store';
import * as AllActions from '../actions';

export interface State {
    authProfile: any;
    assets: any;
    machinePermissions: any;
}

export const initialState: State = {
    authProfile: null,
    assets: null,
    machinePermissions: null
};

const assetsReducer = createReducer(
    initialState,

    // GeTasks
    on(AllActions.AssetsActions.getAssetByOrgId, (state, action) => ({
        ...state,
        assets: action.assets,
        machinePermissions: action.machinePermissions,
        authProfile: action.authProfile
    }))
);

export function reducer(state: State | undefined, action: Action): any {
    return assetsReducer(state, action);
}
